import { TbMessage, TbMessageBolt, TbMessageChatbot, TbMessageExclamation } from "react-icons/tb";

const NotificationIcon = ({ severity, type }) => {
    let color = 'primary';
    let IconElement = TbMessage;
    switch (severity) {
        case 'CRITICAL':
            color = 'danger';
            IconElement = TbMessageExclamation;
            break;
        case 'HIGH':
            IconElement = TbMessageBolt;
            break;
        case 'MEDIUM':
            IconElement = TbMessageChatbot;
            break;
        case 'LOW':
            //IconElement = TbMessageChatbotFilled;
            break;
    }

    switch (type) {
        case 'INFO':
            color = 'info';
            break;
        case 'WARNING':
            color = 'warning';
            break;
        case 'ERROR':
            color = 'danger';
            break;
        case 'SUCCESS':
            color = 'success';
            break;
    }

    return <IconElement className={`text-${color} me-1 flex-shrink-0`} size={24} />;
};

export default NotificationIcon;